var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalThreeDot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99435 8.66106C8.3623 8.66106 8.66058 8.36278 8.66058 7.99484C8.66058 7.62689 8.3623 7.32861 7.99435 7.32861C7.6264 7.32861 7.32812 7.62689 7.32812 7.99484C7.32812 8.36278 7.6264 8.66106 7.99435 8.66106Z",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99435 3.99749C8.3623 3.99749 8.66058 3.69921 8.66058 3.33126C8.66058 2.96332 8.3623 2.66504 7.99435 2.66504C7.6264 2.66504 7.32812 2.96332 7.32812 3.33126C7.32812 3.69921 7.6264 3.99749 7.99435 3.99749Z",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99435 13.3246C8.3623 13.3246 8.66058 13.0264 8.66058 12.6584C8.66058 12.2905 8.3623 11.9922 7.99435 11.9922C7.6264 11.9922 7.32812 12.2905 7.32812 12.6584C7.32812 13.0264 7.6264 13.3246 7.99435 13.3246Z",
    stroke: "#6A7282",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalThreeDot);
export default __webpack_public_path__ + "static/media/vertical_three_dot.ccaa703a23140f60564635f8b9f1a4b2.svg";
export { ForwardRef as ReactComponent };